import * as React from "react";
import { graphql } from "gatsby";
import Seo from "../components/Seo";

import { wpPostYoastSeo } from "../data/fragments";

import Layout from "../components/Layout";
import PageFooterSections from "../components/PageFooterSections";
import Section from "../components/Section";

import Article from "../components/Article";

const Post = ({ data }) => {
    return (
        <Layout>
            {/* SEO Data */}
            <Seo post={data.wpPost} />

            <Section>
                <Article {...data.wpPost} />
            </Section>

            <PageFooterSections
                faqData={data.wpPost.postsRichContent?.faqSection}
            />
        </Layout>
    );
};

export const query = graphql`
    query wpPost($id: String) {
        wpPost(id: { eq: $id }) {
            id
            title
            content
            excerpt
            date(formatString: "DD MMMM YYYY")
            categories {
                nodes {
                    name
                    slug
                }
            }
            # author {
            #   node {
            #     name
            #     nicename
            #   }
            # }
            postsRichContent {
                author
                tableOfContentsBlocks {
                    blockId
                    eyebrow
                    title
                    sections {
                        header
                        subsections {
                            header
                            anchorId
                        }
                    }
                }
                contentDefinitionBlocks {
                    blockId
                    eyebrow
                    label
                    title
                    text
                }
                contentQuoteBlocks {
                    blockId
                    eyebrow
                    quote
                    author
                    role
                }
                contentTakeawaysBlocks {
                    blockId
                    eyebrow
                    label
                    title
                    items {
                        text
                    }
                }
                faqSection {
                    header
                    items {
                        question
                        answer
                    }
                }
                additionalLinks {
                    type
                    link {
                        target
                        title
                        url
                    }
                    text
                    file {
                        localFile {
                            publicURL
                        }
                    }
                }
            }

            ...wpPostYoastSeo
        }
    }
`;

export default Post;
